import { formField } from "src/app/models/formField";
import { GraphQLFormFieldOutput } from "../models/output/graphql-form-field-output";
import { GraphQLFieldTypeEnum } from "../enums/graphql-field-type-enum";
import { FieldTypeEnum } from "src/app/models/enums/fieldTypeEnum";
import { GraphQLResponseOutput } from "../models/output/graphql-response-output";
import { ResponseDto } from "src/app/models/dto/responseDto";
import { GraphQLBaseTestItemOutput, GraphQLLinkOutput, GraphQLLinkPropertyOutput, GraphQLPaginatedBaseTestItemOutput, GraphQLParentItemBasicInfoOutput } from "../models/output/graphql-base-test-item-output";
import { BaseItemsParamsDto, BaseTestItemDto } from "src/app/models/dto/Base-Test-item-dto";
import { BaseTestItemInput } from "../models/input/graphql-base-test-item-input";
import { ParentItemBasicInfo } from "src/app/models/dto/parent-item-basic-info-dto";
import { DataLinkDto } from "src/app/models/dto/dataLinkDto";
import { DataPropertyDto } from "src/app/models/dto/dataPropertyDto";
import { ItemTypeMapper } from "src/app/services/mappers/itemTypeMapper";
import { FormFieldOption } from "src/app/models/formFieldOption";
import { GraphQLItemUidAndTypeOutput } from "../models/output/graphql-item-uid-and-type-output";
import { GraphQLItemTypeEnum } from "../enums/graphql-item-type-enum";
import { ItemType } from "src/app/models/enums/itemType";
import { ItemUidAndTypeDto } from "src/app/models/dto/itemUidAndTypeDto";
import { PaginatedItemsResponseDto } from "src/app/models/dto/paginatedItemsResponseDto";
import { BaseInput } from "../models/input/grahpql-items-params-input";


export function convertGraphqlResponseToDto<T>(input: GraphQLResponseOutput): ResponseDto {
  //To-Do: convert string to localized datetime
  // result.returnValue.creationTime = new Date(new Date(result.returnValue.creationTime + 'Z').toLocaleString());
  // result.returnValue.lockedTime = result.returnValue.lockedTime ? new Date(new Date(result.returnValue.lockedTime + 'Z').toLocaleString()) : result.returnValue.lockedTime;
  const parsed = JSON.parse(input?.returnValue) as any;
  if (parsed)
    parsed.lockedBy = parsed.lockedBy ?? parsed.LockedBy ?? '';

  return {
    success: input.success,
    returnValue: parsed as T,
    responseMessages: input.responseMessages,
  }
}

export function convertGraphqlResponseToDtoSimpleReturnValue(input: GraphQLResponseOutput): ResponseDto {
  return {
    success: input.success,
    returnValue: input.returnValue,
    responseMessages: input.responseMessages,
  }
}

export function convertGraphqlFormFieldToDto(input: GraphQLFormFieldOutput): formField {
    return {
      name: input.Name,
      label: input.Label,
      category: input.Category,
      defaultValue: input.DefaultValue,
      order: input.Order,
      fieldType: convertGraphQLFieldTypeToEnum(input.FieldType),
      tooltip: input.Tooltip,
      isReadOnly: input.IsReadOnly,
      isRequired: input.IsRequired,
      isMultiValue: input.IsMultiValue,
      hasHierarchyValues: input.HasHierarchyValues,
      hierarchialOptions: [],
      options: input.ValueList ? input.ValueList.map(x => ConvertPropertyOptions(x)) : []
    }
  }

export function ConvertPropertyOptions(input: string): FormFieldOption{
 return {
  key: input,
  value: input,
  data: undefined
 }
}

export function convertGraphqlBaseTestItemToDto(input: GraphQLBaseTestItemOutput): BaseTestItemDto {
  return {
    uid: input.Uid,
    itemNo: input.ItemNo,
    name: input.Name,
    version: input.Version,
    createdBy: input.CreatedBy,
    creationTime: input.CreationTime ? new Date(new Date(input.CreationTime + 'Z').toLocaleString()) : null,
    comment: input.Comment,
    lockedBy: input.LockedBy,
    lockedTime: input.LockedTime ? new Date(new Date(input.LockedTime + 'Z').toLocaleString()) : null,
    modificationTime: input.ModificationTime ? new Date(new Date(input.ModificationTime + 'Z').toLocaleString()) : null,
    modifiedBy: input.ModifiedBy,
    approvalStatus: input.ApprovalStatus,
    approvedForTestLevel: input.ApprovedForTestLevel,
    reviewApprovalStatus: input.Approval?.Status,
    reviewApprovalId: input.Approval?.Id,
    reviewApprovalItemVersion: input.Approval?.ItemVersion,
  }
}

/** An item number as either backend generates it: a short letter prefix, a dash, digits (TCA-123, TC-4711). */
const ITEM_NO_PATTERN = /^[A-Za-z]{2,4}-\d+$/;

/**
 * ItemNo/Name pair for an old C# API input. The C# search ANDs its fields and cannot
 * express "item number OR name", so a free-text search (`searchText`) goes to whichever
 * field it looks like: an item number searches ItemNo, anything else searches Name.
 * Without searchText the DTO's own itemNo/name pass through unchanged.
 */
export function oldApiSearchIdentity(input: BaseTestItemDto): { ItemNo: string; Name: string } {
  const text = input.searchText?.trim();
  if (!text) return { ItemNo: input.itemNo, Name: input.name };
  return ITEM_NO_PATTERN.test(text) ? { ItemNo: text, Name: '' } : { ItemNo: '', Name: text };
}

export function convertBaseTestItemDtoToGraphqlInput(input: BaseTestItemDto): BaseTestItemInput {
  return {
    Uid: input.uid,
    ItemNo: input.itemNo,
    Name: input.name,
    Version: input.version,
    CreatedBy: input.createdBy,
    CreationTime: null,
    Comment: input.comment,
    LockedBy: input.lockedBy,
    LockedTime: null,
    ModifiedBy: input.modifiedBy,
    ModificationTime: input.modificationTime ? new Date(new Date(input.modificationTime + 'Z').toLocaleString()) : null,
    ApprovalStatus: input.approvalStatus,
    ApprovedForTestLevel: input.approvedForTestLevel,
  }
}

export function convertGraphqlPaginatedBaseItemToDto(input: GraphQLPaginatedBaseTestItemOutput): PaginatedItemsResponseDto {
  return {
    totalCount: input.TotalItemsCount,
     items: input.Items?.map(item => {
      return convertGraphqlBaseTestItemToDto(item)
    })
  }
}

export function convertBaseItemsParamsDtoToGraphqlInput(input: BaseItemsParamsDto): BaseInput {
  return {
    currentPage: input.currentPage,
    pageSize: input.pageSize,
    regBy: input.regBy ?? '',
    orgGroupId: input.orgGroupId ?? '',
  }
}

export function convertGraphQLParentItemBasicInfoOutputToDto(input: GraphQLParentItemBasicInfoOutput): ParentItemBasicInfo {
  return {
    uid: input.Uid,
    name: input.Name,
    typeName: ItemTypeMapper.map(input.TypeId),
    itemNo: input.ItemNo
  }
}

export function convertGraphQLItemUidAndTypeOutputToDto(input: GraphQLItemUidAndTypeOutput): ItemUidAndTypeDto {
  return {
    uid: input.Uid,
    itemType: convertGraphQLItemTypeToEnum(input.ItemType),
  }
}

export function convertLinkGraphqlToDto(input: GraphQLLinkOutput): DataLinkDto {
  return {
    uid: input.Uid,
    itemUid: input.ItemUid,
    typeId: input.TypeId,
    parentUid: input.ParentUid,
    linkedItemKey: input.LinkedItemKey,
    linkedItemVersion: input.LinkedItemVersion,
    linkedItemName: input.LinkedItemName,
    order: input.Order,
    operator: input.Operator,
    value: input.Value,
    validTo: input.ValidTo ? new Date(input.ValidTo ) : null,
    properties: input.Properties?.map(item => {
      return convertLinkPropertyGraphqlToDto(item)
    })
  }
}

export function convertLinkPropertyGraphqlToDto(input: GraphQLLinkPropertyOutput): DataPropertyDto {
  return {
    uid: input.Uid,
    itemUid: input.ItemUid,
    value: input.Value,
    language: input.Language
  }
}

export function convertGraphQLFieldTypeToEnum(input: GraphQLFieldTypeEnum):FieldTypeEnum {

  switch(input){
    case GraphQLFieldTypeEnum.text:
      return FieldTypeEnum.text;
    case GraphQLFieldTypeEnum.chip:
      return FieldTypeEnum.chip;
    case GraphQLFieldTypeEnum.dropdown:
      return FieldTypeEnum.dropdown;
    case GraphQLFieldTypeEnum.multiselect:
      return FieldTypeEnum.multiselect;
    case GraphQLFieldTypeEnum.number:
      return FieldTypeEnum.number;
    case GraphQLFieldTypeEnum.table:
      return FieldTypeEnum.table;
    case GraphQLFieldTypeEnum.toggle:
      return FieldTypeEnum.toggle;
    case GraphQLFieldTypeEnum.tpc:
      return FieldTypeEnum.tpc;
    case GraphQLFieldTypeEnum.userFunction:
      return FieldTypeEnum.userFunction;
    case GraphQLFieldTypeEnum.tags:
      return FieldTypeEnum.tags;
  }
}


export function convertGraphQLItemTypeToEnum(input: GraphQLItemTypeEnum):ItemType {

  switch(input){
    case GraphQLItemTypeEnum.unsupported:
      return ItemType.Unsupported;
    case GraphQLItemTypeEnum.testCase:
      return ItemType.TestCase;
    case GraphQLItemTypeEnum.testSuite:
      return ItemType.TestSuite;
    case GraphQLItemTypeEnum.testAnalysis:
      return ItemType.TestAnalysis;
    case GraphQLItemTypeEnum.specificationCoverage:
      return ItemType.SpecificationCoverage;
    case GraphQLItemTypeEnum.softwareVersionCoverage:
      return ItemType.SoftwareVersionCoverage;
    case GraphQLItemTypeEnum.testSpecification:
      return ItemType.TestSpecification;
  }
}
